import {useTranslation} from '@/translations/i18n'
import {PatientAgeRange} from '@/types'
import {getPatientServiceType, patientServiceTypeMapToLabel} from '@/utilities/helpers'
import {useMemo} from 'react'

export const PatientAgeServiceType = ({birthDate}: {birthDate: Date}) => {
    const {t} = useTranslation()

    const {serviceType, years, months} = useMemo<{
        serviceType: Exclude<PatientAgeRange, 'evolutionary_age_adults'>
        years: number
        months: number
    }>(() => getPatientServiceType(birthDate), [birthDate])

    return t('commons:patient_age_service_type', {
        serviceType: t(patientServiceTypeMapToLabel[serviceType]),
        age: years > 0 ? `${t('commons:years_age', {count: years})}` : `${t('commons:months_age', {count: months})}`
    })
}
